import { Dialog } from "primereact/dialog";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../../shared/Fetch";
import { JVCheck } from "../../../shared/JVCheck";
import { JVCheckbox } from "../../../shared/JVCheckbox";

interface IStatusMast {
    id?: number,
    status: string,
    active?: boolean,
}

interface IProps {
    open: boolean,
    singleData: any,
    setReLoad: () => void,
    hideDialog: () => void,
    toast: any
}

const schema = yup.object({
    status: yup.string().required("Status Name is required*"),
    // active: yup.boolean().required("Status Active is required*"),
});

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IStatusMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = async (data: IStatusMast) => {
        console.log(data);
        if (data.status.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Status Can not be empty", life: 3000 });
            return;
        }
        setLoading(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const endPoint = props.singleData.id ? "updateEscalationStatus" : "addEscalationStatus";

        const response = await Fetch(("POEscalation/" + endPoint), method, data, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            onHide();
        } else setLoading(false);
    }

    const onHide = () => {
        reset({ status: "", active: true });
        setLoading(false);
        props.setReLoad();
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open) {
            reset(props.singleData);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required column={2} label="State Name" control={control} name="status" error={errors.status?.message} />
                <div className="mt-5">
                    <JVCheckbox column={1} label="Is Active" control={control} name="active" error={errors.active?.message} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} label="SAVE" type={loading === false ? "submit" : "button"} style={{ width: '100px' }} ></Button>
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" ></Button>
                </div>
            </form>
        </Dialog>
    );
}